import v from "@/lib/validator";
import { TFunction } from "i18next";

const RegisterUserSchema = (translate: TFunction, id?: string) => {
    const requiredValidation = v.methods()
        .required({message: translate('usersForm.inputs.errorsMessages.required')})
        .min({length: 4, message: translate('usersForm.inputs.errorsMessages.minCharName')})
        .max({length: 100, message: translate('usersForm.inputs.errorsMessages.maxCharName')});
    const loginValidation = v.methods()
        .required({message: translate('usersForm.inputs.errorsMessages.required')})
        .min({length: 4, message: translate('usersForm.inputs.errorsMessages.minCharLogin')})
        .max({length: 24, message: translate('usersForm.inputs.errorsMessages.maxCharLogin')});
    const passwordValidation = v.methods().min({length: 6, message: translate('usersForm.inputs.errorsMessages.minChar')}).max({length: 24, message: translate('usersForm.inputs.errorsMessages.maxChar')}).regex({pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/, message: translate('login.authErrors.password.regex')})
    const emailValidation = v.methods()
        .required({message: translate('usersForm.inputs.errorsMessages.required')})
        .email({message: translate('usersForm.inputs.errorsMessages.email') || "Formato de e-mail inválido"});

    return v.object({
        nome: requiredValidation,
        email: emailValidation,
        login: loginValidation,
        ...(id ? {} : { senha: passwordValidation }),
        perfil: requiredValidation
    })
}
    
export default RegisterUserSchema